import { render, staticRenderFns } from "./document-builder.vue?vue&type=template&id=720c38b2&"
import script from "./document-builder.vue?vue&type=script&lang=js&"
export * from "./document-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports